module.exports = __webpack_public_path__ + "abb372d5170c5a1680d42737351885d3.png";